/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Art_FootInputs */

const en_svc_rag_art_foot = /** @type {(inputs: Svc_Rag_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source: Handbook · Bookings and cancellations`)
};

const lv_svc_rag_art_foot = /** @type {(inputs: Svc_Rag_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avots: Rokasgrāmata · Rezervācijas un atcelšana`)
};

/**
* | output |
* | --- |
* | "Source: Handbook · Bookings and cancellations" |
*
* @param {Svc_Rag_Art_FootInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_art_foot = /** @type {((inputs?: Svc_Rag_Art_FootInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Art_FootInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_art_foot(inputs)
	return en_svc_rag_art_foot(inputs)
});